
<script>
    import {PATH_PREFIX} from '../../../apiUrls.js';
    export let row;

    function onClick() {
        window.open(`${PATH_PREFIX}/sw/builder/activity/${row.activity}/?tab=failed`);
    }

</script>

<span>
    <span style="border-radius: 8px; padding: 4px 10px 4px 10px; background-color: #dd3b00; color: white" on:click={onClick}>{row.reason}</span>
</span>
